import { useStore } from "@ludens-reklame/rubics-v3-react/store/hooks";
import { transformImageUrl } from "@ludens-reklame/rubics-v3-sdk/file/utils";
import { ThemeSettings } from "../../types/theme.js";

const Header: React.FC = () => {
  const store = useStore<ThemeSettings>();
  const button = store.themeSettings.headerButton;
  const logo = store.themeSettings.headerLogo;

  const handleScroll = () => {
    const targetElement = document.querySelector(".form-component");
    if (targetElement) {
      if (targetElement) {
        targetElement.scrollIntoView({ behavior: "smooth" });
      }
    }
  };

  return (
    <header>
      <div className="component">
        <div className="content mw">
          <div className="left">
            {logo && (
              <img
                src={transformImageUrl(logo, { width: 424 })}
                alt={logo.altText}
              />
            )}
          </div>
          <div className="right">
            {button && (
              <div className="btn-container">
                <button onClick={handleScroll}>{button.title}</button>
              </div>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
